import { PureComponent } from "react";

import ColorfulTitleComponent from "/components/core/colorful-title/colorful-title-component";
import SwitchingWordsComponent from "/components/core/switching-words/switching-words-component";
import classnames from "classnames";
import withResponsiveHOC from "/components/enhancements/responsive-hoc/responsive-hoc-component";

import { StyledSwitchingTitleComponent } from "./switching-title-component.scss";

export class SwitchingTitleComponent extends PureComponent {
  render() {
    const { title, switchingWords, activeIndex, aboveTheFold } = this.props;

    return (
      <StyledSwitchingTitleComponent className={classnames("switching-title-component", { "above-the-fold": aboveTheFold })}>
        <div className="colorful-title-wrapper">
          <ColorfulTitleComponent text={title} />
        </div>

        <div className="switching-words-wrapper">
          <SwitchingWordsComponent {...switchingWords} activeIndex={activeIndex} />
        </div>
      </StyledSwitchingTitleComponent>
    );
  }
}

export class SwitchingTitleMobileComponent extends PureComponent {
  render() {
    const { mobileTitle } = this.props;

    return (
      <StyledSwitchingTitleComponent className="switching-title-component switching-title-mobile-component">
        <div className="colorful-title-wrapper">
          <ColorfulTitleComponent text={mobileTitle} />
        </div>
      </StyledSwitchingTitleComponent>
    );
  }
}

export default withResponsiveHOC(SwitchingTitleComponent, SwitchingTitleMobileComponent);
